import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Project529Service } from '../../../services/project529.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-project529-modal',
  templateUrl: './project529-modal.component.html',
  styleUrls: ['./project529-modal.component.scss']
})
export class Project529ModalComponent {
  @Input() jobcard;
  @Input() bike;
  @Input() messageService;

  public registerPayload: any = {};
  public emailLocked : boolean = false;
  public serialNumberLocked : boolean = false;
  public busyRegistering : boolean = false;
  public errorRegistering : boolean = false;

  public consent: boolean = false;

  constructor(
    public modal: NgbActiveModal,
    private project529Service : Project529Service,
    private translate : TranslateService 
  ) { }

  ngOnInit() {
    this.setRegisterPayload();
  }

  setRegisterPayload() {
    this.registerPayload = {
      serviceID: this.jobcard.ID,
      partnerID: this.jobcard.PartnerID,
      serial_number: this.jobcard.SerialNo,
      email: this.jobcard.Email,
      manufacturer_string: this.bike.Manufacturer ? this.bike.Manufacturer : "",
      model_string: this.bike.Model ? this.bike.Model : "",
      model_year: this.bike.ModelYear && this.bike.ModelYear > 0 ? this.bike.ModelYear : "",
      //bike_type: this.bike.Type ? this.bike.Type : "",
      //shield: "",
      //size: this.bike.BikeSize ? this.bike.BikeSize : "",
      //primary_color: this.bike.Colour ? this.bike.Colour : ""
    }
    if(this.emailValid()){
      this.emailLocked = true;
    }
    if(this.registerPayload.serial_number && this.registerPayload.serial_number.length > 5){
      this.serialNumberLocked = true;
    }
  }

  emailValid() {
    const email = this.registerPayload.email;
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;

    if (!emailRegex.test(email)) {
      return false;
    }else{
      return true;
    }
  }

  valid(){
    return this.emailValid() && this.registerPayload.serial_number && this.registerPayload.serial_number.length > 5;
  }

  register() {
    this.busyRegistering = true;
    this.errorRegistering = false;
    this.project529Service.registerProject529Bike(this.registerPayload).subscribe(res=>{
      if(res && res.id && res.status == "Registered"){
        this.jobcard.project529 = res;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.project_529.registration_success'            
          ),
        });
        this.modal.close();
      }else{
        this.errorRegistering = true;
      }
      this.busyRegistering = false;
    },err=>{

      this.busyRegistering = false;
      this.errorRegistering = true;
    });
  }

}
